export const SET_LOOPS = "setLoops";
export const SET_QUERY_PARAMS = "setQueryParams";
export const CLEAR_QUERY_PARAMS = "clearQueryParams";
export const SET_LOOP_INTERACTIONS = "setLoopInteractions";
export const SET_LOOP = "setLoop";
export const SET_INDICATORS = "setIndicators";
export const CLEAR_LOOP_STATE = "clearLoopState";
export const SET_SEGMENT = "setSegment";
export const SET_NAME = "setName";
export const SET_PRIORITY = "setPriority";
export const SET_TEAMS = "setTeams";
export const SET_AUTO = "setAuto";
export const SET_FINISH_LOOP_TEMPLATE = "setFinishLoopTemplate";
export const SET_SEND_FINISH_EMAIL = "setSendFinishEmail";
export const SET_SENDER_NAME = "setSenderName";
export const CLEAR_LOOP = "clearLoop";
